export class PeriodDTO {
    constructor(
        public start: string,
        public end: string,
        public open: boolean
    ) { }
}
